import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { Attendees } from '../attendee/attendees';
import { Orders } from '../order/orders';

import { ManagerContextProvider } from './components/context';
import PageError from '../error/pageError';

export default function Manager({ path, organization, event }) {
    return (
        <ManagerContextProvider>
            <Switch>
                <Route path={`${path}/attendees`}>
                    <Attendees path={`${path}/attendees`} />
                </Route>
                <Route path={`${path}/orders`}>
                    <Orders path={`${path}/orders`} />
                </Route>
                <Route path={`${path}/products`}></Route>
                <Route path={`${path}/seating`}></Route>
                <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}/E${event.id}/dashboard`} />} />
            </Switch>
        </ManagerContextProvider>
    );
}

Manager.propTypes = {
    path: PropTypes.string.isRequired
};
